export default [
	{
		url:"/home",
		name:"Anasayfa",
		icon:"mdi-home",
	},
	
	
	//{
	//	url:"/login",
	//	name:"Giriş Sayfası",
	//	icon:"mdi-login",
	//},
	//{
		//url:"/register",
		//name:"Kayıt Sayfası",
		//icon:"mdi-cellphone-link",
	//},
	{
		url:"/MyActivities",
		name:"Etkinliklerim",
		icon:"mdi-clipboard-account",
	},
	{
		url:"/TaskManager",
		name:"Görev Atama",
		icon:"mdi-ticket-account",
	},
	/* {
		url:"/LastEvents",
		name:"Son Etkinlikler (1 Ay)",
		icon:"mdi-library-books",
	}, */
	{
		url:"/NewEvent",
		name:"Yeni Etkinlik",
		icon:"mdi-clipboard-account",
	},
	{
		url:"/appeals",
		name:"Etkinlik Kayıt",
		icon:"mdi-clipboard-text",
	},
	{
		url:"/informations",
		name:"Etkinlik Bilgisi",
		icon:"mdi-information-outline",
	},
	
	
	{
		url:"/finishevent",
		name:"Etkinlik Bitir",
		icon:"mdi-send",
	},
	{
		url:"/ends",
		name:"Etkinlik Sonrası",
		icon:"mdi-reply",
	},
	{
		url:"/surveys",
		name:"Anketler",
		icon:"mdi-reply",
	},
	{
		url:"/FolderManagement",
		name:"Etkinlik Dosya Yönetimi",
		icon:"mdi-folder-multiple",
	},
	
	{
		url:"/dashboard",
		name:"Raporlama Ekranı",
		icon:"mdi-home-export-outline",
	},
	{
		url:"/SocialContribution",
		name:"Toplumsal Katkı Ekranı",
		icon:" mdi-earth",
	},
	
	/*
	{
		url:"/institutions",
		name:"'Diğer' Onaylama (admin)",
		icon:"mdi-checkbox-marked-circle-outline",
	},

	{
		url:"/reqqs",
		name:"Dilek/Şikayet Görüntüleme (admin)",
		icon:"mdi-comment-text",
	},

	
	
	{
		url:"/adminedit",
		name:"Düzenleme Ekranları (admin)",
		icon:"mdi-clipboard-text",
	},
	
	{
		url:"/insts",
		name:"OPTIONS insts",
		icon:"mdi-clipboard-text",
	},
	{
		url:"/evs",
		name:"OPTIONS evs",
		icon:"mdi-clipboard-text",
	},
	{
		url:"/roos",
		name:"OPTIONS ros",
		icon:"mdi-clipboard-text",
	},*/
	
	{
		url:"/users",
		name:"Kullanıcı ve Yetki Düzenleme",
		icon:"mdi-account-group",
	},
	
	/*
	{
		url:"/roles",
		name:"Roller",
		icon:"mdi-shield-account",
	},
	{
		url:"/page-not-found",
		name:"Sayfa Bulunamadı",
		icon:"mdi-alert-rhombus-outline",
	},*/
	{
		url:"/analytics",
		name:"Uygulama Log Kayıtları",
		icon:"mdi-chart-areaspline",
	},
	

]